export default `
mutation PublishShifts($shiftIds: [ID!]!) {
  publishShifts(shiftIds: $shiftIds) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    timezone
  }
}
`;